exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deliverable__type__pause__icon {\n  color: var(--wf-secondary);\n  z-index: 100;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  height: 20px;\n  width: 20px;\n  border-radius: 10px;\n  position: absolute;\n  margin-left: 2rem;\n  margin-top: 0.5rem;\n}\n.deliverable__type__pause__icon i {\n  font-size: 0.8rem;\n  position: absolute;\n  margin-left: 0.35rem;\n  margin-top: 0.25rem;\n}", ""]);

// exports
